module.exports = __webpack_public_path__ + "static/media/opensans-regular-webfont.fcd27989.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/static/fonts/opensans-regular-webfont.woff2
// module id = 1013
// module chunks = 0